(() => {
  const normalizeUrl = (url) => {
    try {
      return new URL(url, window.location.origin).href;
    } catch (error) {
      return url;
    }
  };

  const copyMedia = (sourceCard, targetCard) => {
    const sourceImages = Array.from(sourceCard.querySelectorAll('.card__media img'));
    const targetImages = Array.from(targetCard.querySelectorAll('.card__media img'));

    targetImages.forEach((targetImage, index) => {
      const sourceImage = sourceImages[index];

      if (!sourceImage) {
        if (index > 0) targetImage.style.display = 'none';
        return;
      }

      ['src', 'srcset', 'sizes', 'alt', 'width', 'height'].forEach((attribute) => {
        if (sourceImage.hasAttribute(attribute)) {
          targetImage.setAttribute(attribute, sourceImage.getAttribute(attribute));
        } else {
          targetImage.removeAttribute(attribute);
        }
      });

      targetImage.style.display = '';
    });
  };

  const copyPriceAndBadge = (sourceCard, targetCard) => {
    const sourcePrice = sourceCard.querySelector('.card-information .price');
    const targetPrice = targetCard.querySelector('.card-information .price');

    if (sourcePrice && targetPrice) {
      targetPrice.innerHTML = sourcePrice.innerHTML;
      targetPrice.className = sourcePrice.className;
    }

    const sourceBadge = sourceCard.querySelector('.card__badge');
    const targetBadge = targetCard.querySelector('.card__badge');

    if (sourceBadge && targetBadge) {
      targetBadge.innerHTML = sourceBadge.innerHTML;
    }
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.mrvr-card-color-swatch');
    if (!swatch) return;

    const card = swatch.closest('.product-card-wrapper');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    const selectedUrl = normalizeUrl(swatch.href);
    const allSwatches = Array.from(document.querySelectorAll('.mrvr-card-color-swatch'));
    const sourceSwatch = allSwatches.find((candidate) => {
      return candidate.classList.contains('is-active') && normalizeUrl(candidate.href) === selectedUrl;
    });
    const sourceCard = sourceSwatch?.closest('.product-card-wrapper');

    if (sourceCard && sourceCard !== card) {
      copyMedia(sourceCard, card);
      copyPriceAndBadge(sourceCard, card);
    }

    card.querySelectorAll('.mrvr-card-color-swatch').forEach((candidate) => {
      candidate.classList.toggle('is-active', candidate === swatch);
      candidate.setAttribute('aria-current', candidate === swatch ? 'true' : 'false');
    });

    const colorName = card.querySelector('.mrvr-card-color-name');
    if (colorName) colorName.textContent = swatch.getAttribute('title') || '';

    card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
      link.href = swatch.href;
    });
  }, true);
})();